import React, { memo } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

const LabelWithAsterisks = ({ children, asterisksQuantity = 0 }) => {
  return (
    <div className="flex">
      <span className="truncate">{children}</span>
      {asterisksQuantity > 0 ? (
        <span className="ml-2">{_.range(asterisksQuantity).map(() => '*')}</span>
      ) : null}
    </div>
  );
};

LabelWithAsterisks.propTypes = {
  asterisksQuantity: PropTypes.number,
};

export default memo(LabelWithAsterisks);
